// extracted by mini-css-extract-plugin
module.exports = {"container":"CartButton_container__2t4Xc","main":"CartButton_main__jVXuU","button":"CartButton_button__3eyHI","image":"CartButton_image__2Kp2K","badge":"CartButton_badge__2FNoK"};